module.exports = __webpack_public_path__ + "static/media/stefanSchmid.e6fb6648.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/stefanSchmid.jpg
// module id = 1594
// module chunks = 1